export default "__VITE_ASSET__eb0f336e__"